module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-8.0acb0258.png";